import React, { useEffect, useRef, useState } from 'react';
import { RosterAnalyticsHelper } from '@core/Analytics/RosterAnalyticsHelper';
import { RosterTabID } from '@core/Analytics/RosterEvents';
import { TabScreenWrapper } from '@components/General/TabScreen';
import { Flap } from '@models/Flap';
import { Organization } from '@models/Organization';
import RosterScreen from './RosterScreen';
import QontactPointRosterScreen from './QontactPointRosterScreen';

interface RosterTabScreenProps {
    org: Organization;
}

const RosterTabScreen: React.FC<RosterTabScreenProps> = ({ org }) => {
    const [clickedScreen, setClickedScreen] = useState<RosterTabID>('byCollaborator');
    const hasTrackedShownRef = useRef(false);

    useEffect(() => {
        if (hasTrackedShownRef.current) return;
        hasTrackedShownRef.current = true;
        RosterAnalyticsHelper.trackTabShown(clickedScreen);
    }, [clickedScreen]);

    const handleSetClickedScreen = (tabID: string) => {
        const nextTabID = tabID as RosterTabID;
        if (nextTabID !== clickedScreen) {
            RosterAnalyticsHelper.trackTabSelected(nextTabID);
        }
        setClickedScreen(nextTabID);
    };

    const flaps: Flap[] = [
        {
            id: 'byQontactPoint',
            label: 'Por Qontact Point'.localized(),
            width: '250px',
            content: <QontactPointRosterScreen org={org} />,
        },
        {
            id: 'byCollaborator',
            label: 'Por colaborador'.localized(),
            width: '250px',
            content: <RosterScreen org={org} />,
        },
    ];

    return (
        <TabScreenWrapper
            title={'Roster'.localized()}
            subtitle={'Asistencia diaria por turno'.localized()}
            flaps={flaps}
            flag={org.newFlags?.PresenteeismRoster}
            clickedScreen={clickedScreen}
            setClickedScreen={handleSetClickedScreen}
        />
    );
};

export default RosterTabScreen;
